<template>
    <div class="relative font-size-dropdown" @click="showFontSizeDropdown = !showFontSizeDropdown">
        <!-- <button
            
            class="font-size-button"
            :class="{ 'is-active': currentFontSize }"
        >
            {{ currentFontSize || defaultSize }}px
            <svg class="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
        </button> -->
        <Tooltip text="Font Size" position="bottom" class="hidden md:block">
            <button type="button" class="hidden md:block flex items-center justify-center min-w-[3rem] px-3 py-1.5 text-sm rounded-md transition-colors border border-transparent ml-1" 
            :class="currentFontSize ? 'bg-indigo-500 text-white border-indigo-500' : 'text-gray-600 hover:bg-gray-200 dark:text-gray-300 dark:hover:bg-slate-700 dark:hover:text-white'">
                <div class="flex flex-row items-center justify-center">
                    {{ currentFontSize }}px
                    <svg class="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                </div>
            </button>
        </Tooltip>
        <Transition name="fade">
            <div 
                v-if="showFontSizeDropdown" 
                class="font-size-dropdown-menu bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 shadow-lg"
                @click.stop
            >
                <button
                    v-for="size in fontSizes"
                    :key="size"
                    @click="setFontSize(size)"
                    class="flex flex-row items-center justify-start text-sm py-1 px-2 hover:bg-gray-100 dark:hover:bg-slate-700 text-gray-700 dark:text-gray-200 rounded w-full"
                    :class="{ 'bg-indigo-500 text-white dark:bg-indigo-500 dark:text-white hover:bg-indigo-600 dark:hover:bg-indigo-600': currentFontSize === size }"
                >
                    {{ size }}px
                </button>
            </div>
        </Transition>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, defineProps } from 'vue'

const props = defineProps({
    editor: {
        type: Object,
        required: true
    },
    fontSizes: {
        type: Array,
        default: () => [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48]
    },
    defaultSize: {
        type: Number,
        default: 18
    }
})

const showFontSizeDropdown = ref(false)

const currentFontSize = computed(() => {
    if (!props.editor) return props.defaultSize
    const attrs = props.editor.getAttributes('fontSize')
    return attrs.fontSize ? parseInt(attrs.fontSize, 10) : props.defaultSize
})

const setFontSize = (size) => {
    if (!props.editor) return
    props.editor.chain().focus().setFontSize(size).run()
    showFontSizeDropdown.value = false
}

const handleClickOutside = (event) => {
    if (!event.target.closest('.font-size-dropdown')) {
        showFontSizeDropdown.value = false
    }
}

onMounted(() => {
    document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
.font-size-dropdown {
    position: relative;
}

.font-size-dropdown-menu {
    position: absolute;
    top: calc(100% + 0.25rem);
    left: 0;
    border-radius: 0.5rem;
    padding: 0.25rem;
    min-width: 80px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    width: 100px;
}

.font-size-option {
    display: block;
    width: 100%;
    background-color: transparent;
    color: #e5e7eb;
    border: none;
    border-radius: 0.375rem;
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    text-align: left;
    cursor: pointer;
    transition: all 0.15s ease-in-out;
}

.font-size-option:hover {
    background-color: #374151;
    color: #ffffff;
}

.font-size-option.is-selected {
    background-color: #6366f1;
    color: #ffffff;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
